import { render, staticRenderFns } from "./wordList.vue?vue&type=template&id=21f4cb1a&scoped=true"
import script from "./wordList.vue?vue&type=script&lang=js"
export * from "./wordList.vue?vue&type=script&lang=js"
import style0 from "./wordList.vue?vue&type=style&index=0&id=21f4cb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4cb1a",
  null
  
)

export default component.exports